var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7426_7687",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7426_7687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.11572 21L12.2502 3.5L22.3847 21H2.11572ZM4.70022 19.5H19.8002L12.2502 6.5L4.70022 19.5ZM12.2502 18.3077C12.4791 18.3077 12.6709 18.2303 12.8257 18.0755C12.9806 17.9207 13.058 17.7288 13.058 17.5C13.058 17.2712 12.9806 17.0793 12.8257 16.9245C12.6709 16.7697 12.4791 16.6923 12.2502 16.6923C12.0214 16.6923 11.8296 16.7697 11.6747 16.9245C11.5199 17.0793 11.4425 17.2712 11.4425 17.5C11.4425 17.7288 11.5199 17.9207 11.6747 18.0755C11.8296 18.2303 12.0214 18.3077 12.2502 18.3077ZM11.5002 15.6923H13.0002V10.6923H11.5002V15.6923Z",
    fill: "#FBB735"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.7b8efd17906ece119a889f4b4fa23b13.svg";
export { ForwardRef as ReactComponent };